import { ReactElement, ReactNode, useMemo } from 'react'
import { VerticalTransmitterList } from '@structuralPlanningComponents'
import { find } from 'lodash-es'
import { TabContext, TabList } from '@mui/lab'
import { Tab } from '@mui/material'
import { StyledTabPanel } from '@ui/navigation'
import { Box } from '@ui/structure'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'
import { rectangularShapeTabs } from '../../tabs'

interface Props {
  selectedElement: string
  children?: ReactNode
  tab?: ReactNode
  initialTabValue: string
}

const RoofFormBase = ({ children, tab, initialTabValue, selectedElement }: Props): ReactElement => {
  const {
    modes: { isDrawMode },
    params: { verticalTransmitter, activeTab },
    actions: { setVerticalTransmitter, setActiveTab },
  } = useStructuralPlanningSelection()

  const selectedTab = useMemo(() => {
    if (activeTab && find(Object.entries(rectangularShapeTabs), ([, e]) => e.tab === activeTab))
      return activeTab

    return initialTabValue
  }, [activeTab, initialTabValue])

  return (
    <Box>
      <TabContext value={selectedTab}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              fontSize: 12,
              paddingX: ({ spacing }) => spacing(1.5),
            },
          }}
        >
          <TabList onChange={(_, value) => setActiveTab(value)} scrollButtons="auto">
            {tab}
            <Tab
              value={rectangularShapeTabs.verticalTransmission.tab}
              label={rectangularShapeTabs.verticalTransmission.label}
            />
          </TabList>
        </Box>
        {children}
        <StyledTabPanel value={rectangularShapeTabs.verticalTransmission.tab}>
          <VerticalTransmitterList
            selectedElement={selectedElement}
            verticalTransmitter={verticalTransmitter}
            setVerticalTransmitter={(guid, elementGuid) =>
              setVerticalTransmitter(guid, elementGuid, isDrawMode)
            }
          />
        </StyledTabPanel>
      </TabContext>
    </Box>
  )
}

export default RoofFormBase
